const TableLayout = ({ children }: any) => {
    return (
        <div className='tab:bg-white tab:border-2 tab:border-gray-100 tab:rounded-[24px] tab:px-[24px] tab:py-[8px]'>
            {children}
        </div>
    )
}

export default TableLayout